import React from "react";
import PropTypes from "prop-types";

import ConsentModeHelperWeb from "../../../../../lib/ConsentModeHelper/ConsentModeHelperWeb";
import { BodyRegular, Switch } from "../../../common/Typography";

const CookieConsentOptionRow = ({
  consentKey,
  consentOptions,
  label,
  toggleConsentOption
}) => {
  const isRequired = ConsentModeHelperWeb.consentEnabledByDefault.includes(
    consentKey
  );
  const checked = Boolean(consentOptions[consentKey]);

  return (
    <div className="flex align-center justify-between gap-6">
      <BodyRegular tag="span" className="flex-1 opacity-70">
        {label}
      </BodyRegular>
      <Switch
        checked={checked}
        disabled={isRequired}
        aria-label={label}
        onChange={() => toggleConsentOption(consentKey)}
      />
    </div>
  );
};

CookieConsentOptionRow.propTypes = {
  consentKey: PropTypes.string.isRequired,
  consentOptions: PropTypes.objectOf(PropTypes.bool).isRequired,
  label: PropTypes.string.isRequired,
  toggleConsentOption: PropTypes.func.isRequired
};

export default CookieConsentOptionRow;
